<template>
  <div></div>
</template>

<script>
import router from "../router";
export default {
  name: "Home",
  components: {},
  data() {
    return {};
  },
  created() {
    if (localStorage.user != undefined) {
      router.push("/category");
    } else {
      router.push("/login");
    }
  },
};
</script>
<style scoped></style>
